<script setup lang="ts">
  import { useRestaurant } from '@/composition/use-restaurant';
  import { useTimeoutFn } from '@vueuse/core';
  import { computed, ref, watch } from 'vue';
  import ModalPosNewOrderSummaryItems from './ModalPosNewOrderSummaryItems.vue';
  import ModalPosNewOrderSummaryFooter from './ModalPosNewOrderSummaryFooter.vue';

  const restaurantHelper = useRestaurant();

  const bgClass = computed(() => ``);
</script>

<template>
  <div class="pos-summary">
    <v-card class="inner" flat tile>
      <div class="header" :class="bgClass">
        <v-icon size="20">mdi-cart</v-icon>
        <span class="header-title">Pedido</span>
        <div class="spacer"></div>
      </div>
      <div class="content">
        <ModalPosNewOrderSummaryItems />
      </div>
    </v-card>
  </div>
</template>

<style scoped lang="scss">
  .pos-summary {
    @apply tw-flex tw-rounded-lg tw-border tw-border-dashed tw-border-gray-300 tw-overflow-hidden;

    .inner {
      @apply tw-rounded-xl tw-w-full tw-h-full tw-overflow-hidden;
      @apply tw-flex tw-flex-col;

      .header {
        @apply tw-px-4 tw-py-2 tw-flex tw-items-center tw-space-x-1 tw-cursor-pointer tw-h-12 tw-border-b tw-border-dashed tw-flex-none;

        .header-title {
          @apply tw-text-lg tw-font-medium;
        }
      }

      .content {
        @apply tw-flex-1 tw-overflow-y-auto;
      }

      .footer {
        @apply tw-border-t tw-border-dashed tw-flex-none;
      }
    }
  }
</style>
